import { configureStore } from '@reduxjs/toolkit';
import globalReducer from './features/global';

export default configureStore({
  reducer: {
    global: globalReducer,
  },
});